import { AuthState, AuthStatus } from "./types";
import { isAuthDataAvailable } from "./helpers";

const state: AuthState = {
  status: isAuthDataAvailable()
    ? AuthStatus.Uninitialized
    : AuthStatus.Guest,
  user: null
};

export const sliceToken = 'auth';

export default state;
